import React from 'react';
// tslint:disable-next-line:import-spacing
import OldMaintenanceSettingsSection from '../../../../configure/panels/sections/MaintenanceSettingsSection/MaintenanceSettingsSection';

export const Maintenance = () => {
  return <OldMaintenanceSettingsSection />;
};
